// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_PercentualResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Plano Contas Percentual Response
 *
 * Returns the updated conta after changing percentual
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_PercentualResponseDados {
id: number
fechamento_mensal_id: number
franquia_id: number
categoria_id: number
nome_conta: string
operacao: string
tipo: string
percentual_faturamento: string
valor_previsto: string
valor_efetivo: string
created_at: string
updated_at: string
}

export type Planocontas_PercentualResponse = ApiResponse<Planocontas_PercentualResponseDados>;

registerResponseContract('Planocontas_PercentualResponse', {
  id:                     { type: 'number',  required: false },
  fechamento_mensal_id:   { type: 'number',  required: false },
  franquia_id:            { type: 'number',  required: false },
  categoria_id:           { type: 'number',  required: false },
  nome_conta:             { type: 'string',  required: true },
  operacao:               { type: 'string',  required: true },
  tipo:                   { type: 'string',  required: true },
  percentual_faturamento: { type: 'string',  required: false },
  valor_previsto:         { type: 'string',  required: true },
  valor_efetivo:          { type: 'string',  required: true },
  created_at:             { type: 'string',  required: false },
  updated_at:             { type: 'string',  required: false },
})
